import { render, staticRenderFns } from "./RegraItemChecklist.vue?vue&type=template&id=3688269e"
import script from "./RegraItemChecklist.vue?vue&type=script&lang=js"
export * from "./RegraItemChecklist.vue?vue&type=script&lang=js"
import style0 from "./RegraItemChecklist.vue?vue&type=style&index=0&id=3688269e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports